<template>
    <div class="fullscreen">
        <div class="content" :class="{ show: showText && !fadeOut && !showShot }">
            <h2>{{ shotText }}</h2>
            <img v-if="imgSrc" :src="imgSrc" alt="">
            <h1 v-else>x {{ shotsTaken }}</h1>
        </div>
        <div class="water" :class="{ 'fade-out': fullscreen }">
            <div class="waves"></div>
            <div class="fill"></div>
        </div>

        <svg v-if="fullscreen" class="shot-glass" :class="{ zoomed: !showShot }" width="120" height="120" viewBox="0 0 60 80">
            <!-- Glas -->
            <path
                d="M10 20 H50 L44 70 H16 Z"
                fill="none"
                stroke="lightgrey"
                stroke-width="2"
                stroke-linejoin="round"
            />

            <!-- Inhoud -->
            <path
                d="M14 30 H46 L42 67.5 H18 Z"
                fill="#d87e00"
            />
        </svg>
    </div>
</template>

<script>
export default {
    name: 'game-animations',
    components: {
    },
    props: {
        shotsTaken: {
            type: Number,
            default: 0
        }
    },
    data() {
        return {
            showText: false,
            showShot: false,
            fadeOut: false,
            fullscreen: false,
            shotText: ['Tijd voor een shotje!','Vul je shot glas maar!','Jij krijgt een shotje!'][Math.floor(Math.random() * 2.99)],
            imgSrc: ''
        }
    },
    async created() {
        let length = 1400;
        let you = localStorage.getItem('you');
        if (you && JSON.parse(you).id === 'e89a6d73-40bb-4a00-9ee3-ace690e10eca') {
            this.imgSrc = '/img/Steban shot.gif';
            length = 3600;
        }

        await new Promise(r => setTimeout(r, 1600));
        this.showText = true;
        await new Promise(r => setTimeout(r, 400));
        this.fullscreen = true;
        await new Promise(r => setTimeout(r, length));
        this.showShot = true;
        await new Promise(r => setTimeout(r, 2500));
        this.imgSrc = '';
        this.$emit('close');
    }
}
</script>

<style lang="scss" scoped>

.fullscreen {
    position: fixed;
    inset: 0;
    z-index: 500;
    opacity: 1;
    
    &.fade {
        opacity: 0;
        transition: 400ms ease-in-out;
    }

    .content {
        position: absolute;
        inset: 0;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        z-index: 1;
        text-align: center;
        color: white;
        filter: drop-shadow(0 0 4px #00000040);
        scale: 0;
        transition: 400ms ease-in;
        z-index: 2;
        
        &.show {
            scale: 1;
            transition: 1200ms cubic-bezier(.15,.75,.2,1);
        }

        img {
            width: calc(var(--absolute-width) * 0.6);
            border-radius: 12px;
        }

        h2 {
            margin-bottom: 20px;
        }
    }

    .water {
        position: absolute;
        display: flex;
        flex-direction: column;
        width: 100%;
        height: calc(100vh + 150px);
        animation: move-up 2s ease-in forwards;
        filter: brightness(25%) saturate(500%) invert(70%) sepia(60%) saturate(618%) hue-rotate(358deg) brightness(80%) contrast(100%);
        z-index: 1;

        &.fade-out {
            opacity: 0;
            transition: 1200ms ease;
        }

        .waves {
            height: 150px;
            background: url('/img/wave.png');
            background-size: 1000px 150px;
            animation: sideways 700ms linear infinite;
        }

        .fill {
            background: white;
            width: 100%;
            height: 100dvh;
        }
    }
    .shot-glass {
        position: absolute;
        left: 50%;
        top: 50%;
        translate: -50% -70%;
        width: 300px;
        height: 300px;
        scale: 1;
        transition: 500ms ease;
        animation: shot 800ms ease 2200ms forwards;
        
        &.zoomed {
            width: 100dvw;
            height: 100dvh;
            scale: 4;
        }
    }
    
}

@keyframes shot {
    to {
        translate: 80% -150%;
        rotate: 140deg;
    }
}

@keyframes sideways {
    from {
        background-position-x: 0px;
    } to {
        background-position-x: 1000px;
    }
}

@keyframes move-up {
    from {
        top: calc(100dvh + 50px);
        // filter: sepia(400%) saturate(1000%) hue-rotate(0deg);
    } to {
        top: -150px;
        // filter: sepia(400%) saturate(1000%) hue-rotate(360deg);
    }
}

</style>